import { render, staticRenderFns } from "./OnlineChannelsMenu.vue?vue&type=template&id=f2404786&scoped=true&"
import script from "./OnlineChannelsMenu.vue?vue&type=script&lang=js&"
export * from "./OnlineChannelsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2404786",
  null
  
)

export default component.exports